// frontend/src/components/LoadingSpinner.js
// Componente de spinner de carga reutilizable.

import React from 'react';

/**
 * @component LoadingSpinner
 * @description Muestra un spinner de carga animado.
 * @param {object} props - Propiedades del componente.
 * @param {string} [props.size='md'] - Tamaño del spinner ('sm', 'md', 'lg').
 * @param {string} [props.color='text-blue-500'] - Color del spinner (clase de Tailwind CSS).
 * @param {string} [props.className=''] - Clases CSS adicionales para el contenedor.
 */
function LoadingSpinner({ size = 'md', color = 'text-blue-500', className = '' }) {
  let spinnerSizeClasses = '';
  switch (size) {
    case 'sm':
      spinnerSizeClasses = 'w-6 h-6 border-2';
      break;
    case 'lg':
      spinnerSizeClasses = 'w-12 h-12 border-4';
      break;
    case 'md':
    default:
      spinnerSizeClasses = 'w-8 h-8 border-3';
      break;
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`inline-block animate-spin rounded-full border-t-transparent border-solid ${spinnerSizeClasses} ${color}`}
        role="status"
      >
        <span className="sr-only">Cargando...</span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
